import type { Playlist, DisplayOrientation } from '../../../components/display/data/types';

export const PLAYLIST_FETCH_REQUEST = 'playlist/FETCH_REQUEST';
export const PLAYLIST_FETCH_SUCCESS = 'playlist/FETCH_SUCCESS';
export const PLAYLIST_FETCH_FAILURE = 'playlist/FETCH_FAILURE';

// ── Real backend — POST /display/playlist, POST /display/playlist/{id}, DELETE /display/playlist/{id} ──
export const PLAYLIST_CREATE_REQUEST = 'playlist/CREATE_REQUEST';
export const PLAYLIST_UPDATE_REQUEST = 'playlist/UPDATE_REQUEST';
export const PLAYLIST_DELETE_REQUEST = 'playlist/DELETE_REQUEST';

// ── Local-only — inserts/updates/removes the server-confirmed item in state ──
export const PLAYLIST_ADD = 'playlist/ADD';
export const PLAYLIST_UPDATE = 'playlist/UPDATE';
export const PLAYLIST_DELETE = 'playlist/DELETE';

export interface Deferred<T = void> {
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (e: Error) => void;
}

export interface PlaylistFetchRequestPayload {
  locationId: string;
}

export interface PlaylistCreateRequestPayload {
  locationId: string;
  name: string;
  orientation: DisplayOrientation;
  mediaIds: string[];
  deferred: Deferred<Playlist>;
}

export interface PlaylistUpdateRequestPayload extends PlaylistCreateRequestPayload {
  id: string;
}

export interface PlaylistDeleteRequestPayload {
  id: string;
  locationId: string;
  deferred: Deferred;
}

export interface PlaylistState {
  items: Playlist[];
  loading: boolean;
  error: string | null;
}
